import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const StatusDashboardPage = withSuspense(
	lazy(async () => await import('./status-dashboard-page.component')),
	PageLoader,
);
